/**
 * Moduli gestionali dei template di stampa (enum Prisma `ModuloReport`).
 *
 * Unico elenco per la lista di Impostazioni → Report e per l'editor dei
 * template: un valore nuovo dell'enum va aggiunto qui (e in
 * `backend/src/config/moduliStampa.js` per i permessi di stampa).
 */
export const MODULI_REPORT = [
  'PREVENTIVO',
  'ORDINE_CLIENTE',
  'COMMESSA',
  'DISTINTA',
  'DDT',
  'SAL',
  'PROFORMA_ACCONTO',
  'FATTURA',
  'ORDINE_FORNITORE',
  'CARICO_MERCE',
  'CAPITOLATO',
  'OFFERTA_CAPITOLATO',
  'DATI_SOCIETARI',
  'MOVIMENTI_ANALITICA',
  'BILANCIO_ANALITICA',
  'ORDINE_GO',
  'GENERICO',
] as const;

export type ModuloReport = typeof MODULI_REPORT[number];

export const MODULO_REPORT_LABEL: Record<string, string> = {
  PREVENTIVO: 'Preventivo',
  ORDINE_CLIENTE: 'Ordine cliente',
  COMMESSA: 'Commessa',
  DISTINTA: 'Distinta merce / lavorazioni',
  DDT: 'DDT cliente',
  SAL: 'SAL (stato avanzamento lavori)',
  PROFORMA_ACCONTO: 'Proforma acconto',
  FATTURA: 'Fattura',
  ORDINE_FORNITORE: 'Ordine fornitore',
  CARICO_MERCE: 'Carico merce',
  CAPITOLATO: 'Capitolato',
  OFFERTA_CAPITOLATO: 'Offerta capitolato',
  DATI_SOCIETARI: 'Dati societari',
  MOVIMENTI_ANALITICA: 'Movimenti contab. analitica',
  BILANCIO_ANALITICA: 'Bilancio contab. analitica',
  ORDINE_GO: 'Ordine di vendita GO',
  GENERICO: 'Generico',
};

export const BADGE_MODULO_REPORT: Record<string, string> = {
  PREVENTIVO: 'bop-badge-warning',
  ORDINE_CLIENTE: 'bop-badge-warning',
  COMMESSA: 'bop-badge-info',
  DISTINTA: 'bop-badge-info',
  DDT: 'bop-badge-info',
  SAL: 'bop-badge-warning',
  PROFORMA_ACCONTO: 'bop-badge-warning',
  FATTURA: 'bop-badge-info',
  ORDINE_FORNITORE: 'bop-badge-success',
  CARICO_MERCE: 'bop-badge-success',
  CAPITOLATO: 'bop-badge-success',
  OFFERTA_CAPITOLATO: 'bop-badge-success',
  DATI_SOCIETARI: 'bop-badge-info',
  MOVIMENTI_ANALITICA: 'bop-badge-warning',
  BILANCIO_ANALITICA: 'bop-badge-success',
  ORDINE_GO: 'bop-badge-info',
  GENERICO: 'bop-badge-neutral',
};
